import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { AreaDetailPage, AreasListPage } from 'pages/Areas';

const areasRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/areas',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <AreasListPage />,
    },
    {
      path: ':areaId',
      element: <AreaDetailPage />,
    },
  ],
});

export default areasRoutes;
